module.exports = __webpack_public_path__ + "img/sec-text-section.9dd1f7a0.svg";